module.exports = __webpack_public_path__ + "static/01-7e95fda5ae4f21f08f68379a48950193.jpg";